import { useLocation } from "react-router-dom";
import * as React from "react";

import { Alert, Typography } from "mpulse-design-system";
import { styled } from "@mui/material";

import constants from "../../constants";

const LoginTitle = ({
  wrongPassword,
  serverError,
  tooManyClients,
  sessonExpired,
}) => {
  const location = useLocation(),
    userLoggedOut = location.state?.userLoggedOut || false,
    title = userLoggedOut
      ? constants.login.title.signOut
      : sessonExpired
      ? constants.login.title.sessionExpired
      : constants.login.title.signIn;

  const signedOut = userLoggedOut ? (
    <StyledAlert severity="success" data-testid="signed-out-message">
      {constants.login.alerts.signedOut}
    </StyledAlert>
  ) : null;

  const error =
    wrongPassword || serverError || tooManyClients ? (
      <StyledAlert severity="error">
        {wrongPassword
          ? constants.login.alerts.wrongPassword
          : serverError
          ? constants.common.serverError
          : tooManyClients
          ? constants.login.alerts.multiClientError
          : null}
      </StyledAlert>
    ) : null;

  const info = sessonExpired ? (
    <StyledAlert severity="info">
      {constants.login.alerts.sessionExpired}
    </StyledAlert>
  ) : null;

  // Reset Location state
  if (userLoggedOut) {
    window.history.replaceState({}, document.title);
  }

  return (
    <>
      <Typography
        variant="h1"
        color="textPrimary"
        sx={{ marginBottom: (theme) => theme.spacing(4) }}
        data-testid="sign-in-title-test-id"
      >
        {title}
      </Typography>
      {error ? error : info ? info : signedOut}
    </>
  );
};

const StyledAlert = styled(Alert)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export default LoginTitle;
